import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import {
  Button,
  message,
  Layout,
  Menu,
  Input,
  Form,
  Card,
  Tabs,
  DatePicker,
  Select,
  Table,
  Pagination,
  Modal,
  Spin,
  Popconfirm,
  Image,
  Upload,
  InputNumber,
  Cascader,
  Skeleton,
  Empty,
  Radio,
  ConfigProvider,
  RadioButton,
  RadioGroup,
} from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
import "@/assets/common.less";
// import * as Icons from "@ant-design/icons-vue";
import "@/styles/index.less";
import "@/permission.ts";

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(Button)
  .use(Layout)
  .use(Menu)
  .use(Input)
  .use(Empty)
  .use(Card)
  .use(Tabs)
  .use(Radio)
  .use(DatePicker)
  .use(Select)
  .use(Table)
  .use(Pagination)
  .use(Modal)
  .use(Spin)
  .use(Popconfirm)
  .use(Image)
  .use(Upload)
  .use(InputNumber)
  .use(Cascader)
  .use(Skeleton)
  .use(ConfigProvider)
  .use(Form);
app.config.globalProperties.$message = message;
app.mount("#app");
